(function () {
    'use strict';

    // This file contains patches to the jQgrid library that fix bugs resulting from the jQuery upgrade (FB 21619).

    $.ui.multiselect.prototype._populateLists = function(options) {
        this.selectedList.children('.ui-element').remove();
        this.availableList.children('.ui-element').remove();
        this.count = 0;

        var that = this;
        var items = $(options.map(function (i) {
            // 11/16/2015 - Ellis - Leica Biosystems
            // this property is no longer set as of jQuery v 2.1.4 and jQueryUI v 1.11.4
            this.selected = $(this).attr('selected') == 'selected';
            // END 11/16/2015
            var item = that._getOptionNode(this).appendTo(this.selected ? that.selectedList : that.availableList).show();

            if (this.selected) that.count += 1;
            that._applyItemState(item, this.selected);
            item.data('idx', i);
            return item[0];
        }));

        // update count
        this._updateCount();
    };

    $.ui.multiselect.prototype._setSelected = function(item, selected) {
        // 12/07/2015 - Ellis/Camaratta - Leica Biosystems
        // Calling attr('selected', true) no longer sets element.selected to true (as of jQuery v 2.1.4 and jQueryUI v 1.11.4)
        var optionLink = item.data('optionLink');
        optionLink.attr('selected', selected);
        optionLink[0].selected = selected;
        // END 12/07/2015

        if (selected) {
            var selectedItem = this._cloneWithData(item);
            item[this.options.hide](this.options.animated, function () {
                $(this).remove();
            });
            selectedItem.appendTo(this.selectedList).hide()[this.options.show](this.options.animated);

            this._applyItemState(selectedItem, true);
            return selectedItem;
        } else {

            // look for successor based on initial option index
            var items = this.availableList.find('li'), comparator = this.options.nodeComparator;
            var succ = null, i = item.data('idx'), direction = comparator(item, $(items[i]));

            // TODO: test needed for dynamic list populating
            if (direction) {
                while (i >= 0 && i < items.length) {
                    direction > 0 ? i++ : i--;
                    if (direction != comparator(item, $(items[i]))) {
                        // going up, go back one item down, otherwise leave as is
                        succ = items[direction > 0 ? i : i + 1];
                        break;
                    }
                }
            } else {
                succ = items[i];
            }

            var availableItem = this._cloneWithData(item);
            succ ? availableItem.insertBefore($(succ)) : availableItem.appendTo(this.availableList);
            item[this.options.hide](this.options.animated, function () {
                $(this).remove();
            });
            availableItem.hide()[this.options.show](this.options.animated);

            this._applyItemState(availableItem, false);
            return availableItem;
        }
    };
}());
